import { usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import { useTriggeredMessagesListQuery } from '@occc/graphql';
import { usePaginationParams } from '@occc/utils-query-params';

import { TRIGGERED_MESSAGES_LIST_QUERY_PAGE_SIZE } from '../triggered-messages-list.constants';
import { mapEdgesToTriggeredMessagesArray } from '../triggered-messages-list.utils';

export const useGetTriggeredMessages = (scope?: string) => {
  const [pagination, setPagination] = usePaginationParams({
    pageSize: TRIGGERED_MESSAGES_LIST_QUERY_PAGE_SIZE,
  });

  const response = usePaginatedQuery(
    useTriggeredMessagesListQuery,
    'triggeredMessagesList.pageInfo',
    undefined,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        filter: scope ? { subBrandUuidEquals: scope } : undefined,
      },
    },
    pagination,
    setPagination,
  );

  return {
    ...response,
    data: response.data
      ? mapEdgesToTriggeredMessagesArray(response.data.triggeredMessagesList.edges)
      : response.data,
  };
};
